import { createContext } from './createContext';
import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const store = createApplicationState();
  const context = createContext();

  renderApplication({ store, context });
}
